
import React, { useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import ErrorMessage from 'components/common/ErrorMessage';
import toast from 'react-hot-toast';
import { Spinner } from 'reactstrap';
import Api from "services/api"
import { CustomSwitch } from 'components/common/Switch';
import { setError, fetchFacilities, addFacility, updateFacility, facilitiesSelector } from 'slices/facilitiesSlice';

const AddFacilityForm = ({ item, handleClose, callback, show, statusPerm }) => {
    const dispatch = useDispatch()
    const { register, handleSubmit, watch, formState: { errors }, control, setValue, } = useForm();
    const { error, loader } = useSelector(facilitiesSelector);
    const [buttonLoader, setButtonLoader] = useState(false)

    useEffect(() => {
        setValue('facility', item?.facility || item?.abbreviation || item?.name || '')
        setValue('status', (typeof (item?.status) == "number") ? item?.status : 1)
        dispatch(setError({}))
    }, [item])

    const ResetField = () => {
        setValue('facility', '');
        setValue('status', 1)
    }

    useEffect(() => {
        !show && ResetField();
        return () => ResetField()
    }, [show])

    const submitCallback = (status, message) => {
        if (status) {
            callback()
            toast.success(message, {
                className: "successToast",
            })
            handleClose()
            ResetField()
            setButtonLoader(false)
            dispatch(fetchFacilities(1))
        }
        else {
            toast.error(message, {
                className: "errorToast",
            });
            setButtonLoader(false)
        }
    };

    const onSubmit = (data) => {
        setButtonLoader(true)
        const payload = {
            facility: data.facility,
            status: data.status
        }
        if (item?.id) {
            dispatch(updateFacility(payload, item?.id, submitCallback, false));
        }
        else
            dispatch(addFacility(payload, submitCallback, false));
    }

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row-primary">
                <h2>Facility Name *</h2>
                <div className="w-100">
                    <Controller
                        name="facility"
                        control={control}
                        rules={{
                            required: 'Facility name is required'
                        }}
                        render={({ field }) => <input className="input-in type_inp" type="text" name='facility' placeholder='Facility Name' {...field} />}
                    />
                    {errors?.facility?.message &&
                        <div style={{ marginBottom: 10 }}>
                            <ErrorMessage text={errors?.facility?.message} />
                        </div>
                    }
                </div>
            </div>

            {statusPerm &&
                <div className="row-primary" style={{ alignItems: "center" }}>
                    <h2>Status</h2>
                    <Controller name="status" control={control} required
                        rules={{
                            required: true
                        }}
                        render={({ field }) => (
                            <CustomSwitch labelText={field.value == 1 ? "Active" : "Inactive"} checked={field.value} handleChange={(checked) => field.onChange(checked ? 1 : 0)} />
                        )}
                    />
                </div>
            }

            <div className="Form-footer">
                <button type="button" className="Cancle_button" data-bs-dismiss="modal">Cancel</button>
                <button type="submit" disabled={buttonLoader ? 'disabled' : ''} className="main_button">
                    {buttonLoader ?
                        <>
                            <Spinner size="sm">
                                Loading...
                            </Spinner>
                            <span> Loading</span>
                        </>
                        :
                        <span>
                            {item?.id ? "Update" : "Create"}
                        </span>
                    }
                </button>
            </div>
        </form>
    )
}

const AddFacility = ({ item, onClose, callback, show, statusPerm }) => {
    return (
        <div className={`modal fade`} id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" role="dialog">
            <div className="modal-dialog modal-dialog-centered modal-lg">
                <div className="modal-content full_modal">
                    <div className="modal-header header_modal align-items-center">
                        <div></div>
                        <h5 className="modal-title_u">{item?.id ? "Update" : "Add"} Facility</h5>
                        <button onClick={onClose} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body modal_form_body">
                        <AddFacilityForm item={item} handleClose={onClose} show={show} callback={callback} statusPerm={statusPerm} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AddFacility
